const typesPokemons = [
  "All",
  "Fire",
  "Water",
  "Grass",
  "Flying",
  "Normal",
  "Fighting",
  "Poison",
  "Electric",
  "Ground",
  "Rock",
  "Psychic",
  "Ice",
  "Bug",
  "Ghost",
  "Steel",
  "Dragon",
  "Dark",
  "Fairy",
]

export default typesPokemons
